import { AxiosResponse } from "axios";
import $api from "../http";
import { IPosition } from "../models/IPosition";
export default class PositionService {
  static fetchPosition(): Promise<AxiosResponse<IPosition[]>> {
    return $api.get<IPosition[]>("/positions");
  }
}
